module.exports = __webpack_public_path__ + "img/hp.bfeece63.png";